<template>
  <div class="">
    <hr>
    <div class="my-2">
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">شناسه: {{ item.id }}</span>
      <div class="form-group d-inline-block">
        <input :id="`secure-${item.id}`" type="checkbox" v-model="item.security">
        <label :for="`secure-${item.id}`" class="mx-2 d-inline-block">محافظت شده</label>
      </div>
    </div>
    <div class="form-group">
      <input type="text" class="mb-2 form-control" v-model="item.title">

      <div class="form-group">
        <input type="range" class="form-control-range"
               :min="item.config.min"
               :max="item.config.max"
               :step="item.config.step"
               id="formControlRange">
      </div>


      <div class="row">
        <div class="col">
          <label for="">کمترین مقدار</label>
          <input type="text" class="mb-2 form-control" v-model="item.config.min">
        </div>
        <div class="col">
          <label for="">بیشترین مقدار</label>
          <input type="text" class="mb-2 form-control" v-model="item.config.max">
        </div>
        <div class="col">
          <label for="">مقدار حرکت اسلایدر</label>
          <input type="text" class="mb-2 form-control" v-model="item.config.step">
        </div>
      </div>


    </div>
    <b-icon class="bg-danger d-inline p-1 rounded-pill mx-2 h3 text-white  my-2" icon="trash"
            @click="deleteQuestion()"/>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "RangeInput",
  props: {
    item: {}
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>

</style>